<template>
  <div class="w-full">
    <!--Banner 区域 -->
    <img
      v-if="productDetail?.bgImage || !loading"
      :src="productDetail?.bgImage"
      alt="product-bg"
      class="w-full h-auto md:h-full object-cover"
    />
    <div
      v-if="loading"
      class="w-full h-[400px] bg-gray-200 flex items-center justify-center"
    >
      <div class="text-gray-500">加载中...</div>
    </div>

    <!-- 产品介绍区域 -->
    <div class="product-intro bg-[#0C3D8E] w-full pt-8 sm:pt-12 md:pt-16 lg:pt-[68px] pb-8 sm:pb-12 md:pb-16 lg:pb-[61px]">
      <div class="container mx-auto px-4 sm:px-6 md:px-8">
        <div class="flex flex-col items-center justify-center text-center">
          <img
            src="../../assets/img/product-info.webp"
            alt="product-info"
            class="mb-6 sm:mb-8 md:mb-10 lg:mb-[46px] w-full max-w-[100px] sm:max-w-[122px] md:max-w-[144px] lg:max-w-[265px] scroll-fade-in"
          />
          <!-- 副标题 -->
          <p class="text-white text-base sm:text-lg md:text-xl lg:text-2xl font-bold mb-6 sm:mb-8 md:mb-10 lg:mb-[54px] px-4 scroll-fade-in">
            {{ productDetail?.subtitle }}
          </p>

          <!-- 正文内容 -->
          <div class="text-white text-sm sm:text-base md:text-lg lg:text-2xl max-w-[1292px] text-center font-normal px-4 scroll-fade-in">
            <p
              class="text-center"
              v-html="productDetail?.desc"
            ></p>
          </div>
        </div>
      </div>
    </div>

    <!-- 场景效果区域 -->
    <div class="scene-effects bg-black w-full pt-8 sm:pt-12 md:pt-16 lg:pt-[68px] pb-8 sm:pb-12 md:pb-16 lg:pb-[82px]">
      <div class="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-8">
        <div class="flex flex-col items-center justify-center text-center">
          <img
            src="../../assets/img/Scene.webp"
            alt="scene"
            class="mb-6 sm:mb-8 md:mb-10 lg:mb-[50px] w-full max-w-[100px] sm:max-w-[122px] md:max-w-[144px] lg:max-w-[205px] scroll-fade-in"
          />
        </div>

        <!-- 场景效果图片网格 -->
        <div class="container mx-auto px-4 sm:px-6 md:px-8">
          <div
            v-if="loading"
            class="text-white text-center py-8"
          >
            加载中...
          </div>
          <div
            v-else-if="productDetail?.items?.length > 0"
            class="grid grid-cols-1 md:grid-cols-2 gap-y-4 sm:gap-y-6 md:gap-y-8 lg:gap-y-[48px] w-full"
            :class="{
              'lg:grid-cols-1': productDetail.items.length === 1,
              'lg:grid-cols-2': productDetail.items.length === 2,
              'lg:grid-cols-3': productDetail.items.length === 3,
              'lg:grid-cols-4': productDetail.items.length >= 4
            }"
          >
            <div
              v-for="(item, index) in productDetail.items"
              :key="`item-${index}`"
              class="relative w-full h-[300px] sm:h-[400px] md:h-[500px] lg:h-[750px] bg-cover bg-center px-4 sm:px-6 md:px-8 lg:px-[54px] flex flex-col items-center justify-center group cursor-pointer transition-all duration-300"
              :style="{ backgroundImage: `url(${item.bgImage})` }"
              :class="{
                'items-start': productDetail.items.length < 4,
              }"
            >
              <!-- 桌面端hover时的背景蒙层 -->
              <div class="absolute inset-0 bg-black/30 opacity-100 transition-opacity duration-300 pointer-events-none"></div>
              <!-- 文字内容区域-->
              <div class="absolute top-[30%] left-[54px] right-[54px] z-10  transition-opacity duration-300">
                <div class="text-white text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-left">{{ item.title
                  }}</div>
                <div class="w-[60px] sm:w-[80px] lg:w-[100px] h-1 bg-[#0BE0BB] rounded-[2px] mt-2 sm:mt-[6px] mb-3 sm:mb-5">
                </div>
                <div
                  v-if="item.content"
                  class="text-white text-xs sm:text-sm md:text-base lg:text-[16px] font-normal text-left"
                >{{
                  item.content }}</div>
              </div>
            </div>
          </div>
          <!-- 默认场景效果（当接口未返回数据时显示） -->
          <div
            v-else-if="!loading && scenes.length > 0"
            class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-y-4 sm:gap-y-6 md:gap-y-8 lg:gap-y-[48px] lg:gap-x-0 w-full"
          >
            <div
              v-for="(scene, index) in scenes"
              :key="index"
              class="w-full h-[300px] sm:h-[400px] md:h-[500px] lg:h-[750px] bg-cover bg-center px-4 sm:px-6 md:px-8 lg:px-[54px] flex flex-col items-center justify-center group cursor-pointer transition-all duration-300"
              :class="index % 2 === 0 ? 'scroll-fade-in-left' : 'scroll-fade-in-right'"
              :style="{ backgroundImage: `url(${scene.image})` }"
            >
              <!-- 文字内容区域，默认显示 -->
              <div>
                <div class="text-white text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-center">{{ scene.title
                  }}</div>
                <div class="w-[60px] sm:w-[80px] lg:w-[100px] h-1 bg-[#0BE0BB] rounded-[2px] mt-2 sm:mt-[6px] mb-3 sm:mb-5 mx-auto">
                </div>
                <div class="text-white text-xs sm:text-sm md:text-base lg:text-[16px] font-normal text-center">{{
                  scene.description }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <!--应用案例 -->
    <div class="bg-[#0C3D8E] w-full pt-8 sm:pt-12 md:pt-16 lg:pt-[68px] pb-8 sm:pb-12 md:pb-16 lg:pb-[82px]">
      <div class="flex flex-col items-center justify-center">
        <img
          src="../../assets/img/appCases.webp"
          class="pb-6 sm:pb-8 md:pb-10 lg:pb-[46px] max-w-[100px] sm:max-w-[122px] md:max-w-[144px] scroll-fade-in"
        >

        <!-- 案例卡片 -->
        <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-4 lg:grid-cols-4 gap-4 sm:gap-6 md:gap-[16px] flex-wrap px-4 max-w-[1500px] w-full">
          <!-- 前三个案例卡片 -->
          <div
            v-for="(item, index) in serviceCaseList"
            :key="index"
            class="relative w-full h-[280px] sm:h-[300px] md:h-[320px] lg:h-[340px] rounded-[8px]  overflow-hidden cursor-pointer transition-transform duration-500 ease-out hover:scale-[1.03] hover:shadow-[0_0_24px_rgba(41,255,248,0.25)]"
            :class="index % 2 === 0 ? 'scroll-fade-in-left' : 'scroll-fade-in-right'"
            :style="{ transitionDelay: (index * 40) + 'ms' }"
            @click="goToCaseDetail(item.id)"
          >
            <!-- 背景图片 -->
            <img
              :src="item.image"
              :alt="item.title"
              class="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out hover:scale-105"
            >
            <!-- 下半部分透明遮罩层 -->
            <div class="absolute bottom-0 left-0 right-0 h-[40%] bg-gradient-to-t from-[#07409D] to-[#FFFFFF]/50"></div>
            <!-- 文字内容 -->
            <div class="absolute bottom-0 left-0 right-0 p-3 sm:p-4 pb-[12px] pl-6 flex flex-col">
              <div class="text-white text-[14px] sm:text-[16px] md:text-[18px] font-black mb-1 sm:mb-[4px] truncate">{{ item.title }}</div>
              <p class="text-white/90 title-family-12 text-[12px] sm:text-[13px] md:text-[14px] leading-relaxed mb-2 sm:mb-3 line-clamp-2">{{ item.description }}</p>
              <a
                @click.prevent="goToCaseDetail(item.id)"
                :href="item.link"
                class="text-[#29FFF8] font-normal sm:text-[13px] md:text-[14px] hover:opacity-80 transition-opacity self-start"
              >查看详情>>></a>
            </div>
          </div>
          <!-- 第四个：查看更多卡片 -->
          <div
            class="relative w-full h-[280px] sm:h-[300px] md:h-[320px] lg:h-[340px] rounded-[8px] cursor-pointer transition-transform duration-500 ease-out hover:scale-[1.03] hover:shadow-[0_0_24px_rgba(41,255,248,0.25)] scroll-fade-in-right more-case-card"
            style="overflow: visible; background: linear-gradient(to bottom, rgba(255, 255, 255, 0.5), rgba(7, 64, 157, 1));"
            :style="{ transitionDelay: '120ms' }"
            @click="goToServicePage"
          >

            <!-- 内容区域 -->
            <div class="absolute inset-0 flex flex-col items-center justify-center">
              <!-- 虚线圆形边框和箭头图标 -->
              <div
                class="relative w-[168px] h-[168px] flex flex-col items-center justify-center mb-3 sm:mb-4"
                style="overflow: visible;"
              >
                <!-- 虚线圆形边框 -->
                <svg
                  viewBox="0 0 100 100"
                  width="168"
                  height="168"
                  preserveAspectRatio="xMidYMid meet"
                  style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); overflow: visible;"
                >
                  <circle
                    cx="50"
                    cy="50"
                    r="50"
                    fill="none"
                    stroke="rgba(147, 178, 229, 1)"
                    stroke-width="2"
                    stroke-dasharray="4,4"
                  />
                </svg>
                <!-- 三个右箭头 -->
                <img
                  src="../../assets/img/more.webp"
                  alt="right-arrow"
                  class="lg:mt-[45px] lg:mb-[9px]"
                >
                <!-- 查看更多文字 -->
                <div class="text-white text-sm font-400">查看更多</div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 方案咨询 -->
    <div class="consultation-section relative w-full pt-12 sm:pt-16 md:pt-20 lg:pt-[68px] pb-12 sm:pb-16 md:pb-20 lg:pb-[101px] bg-[#04193B]">
      <div class="max-w-[1200px] mx-auto px-4 sm:px-6 md:px-8">
        <div class="flex flex-col items-center justify-center text-center">
          <img
            src="../../assets/img/solution-c.webp"
            alt="consultation"
            class="
            scroll-fade-in
            mb-6 sm:mb-8 md:mb-10 lg:mb-[46px] w-full max-w-[100px] sm:max-w-[122px] md:max-w-[144px] lg:max-w-[205px]"
          >
          <!-- 描述文字 -->
          <p class="text-white text-base sm:text-lg md:text-xl lg:text-2xl leading-relaxed max-w-[800px] mb-8 sm:mb-10 md:mb-12 px-4 scroll-fade-in">
            想让你的 VR 亲子 / LBE 场馆运营效率翻倍？立即咨询获取专属方案
          </p>
          <!-- 立即咨询按钮 -->
          <button
            class="px-6 sm:px-8 md:px-12 lg:px-[50px] py-3 sm:py-4 md:py-5 lg:py-[20px] border-2 border-[#FFFFFF] rounded-xl lg:rounded-[16px] text-[#29FFF8] text-base sm:text-lg md:text-xl lg:text-[36px] font-bold hover:bg-[#0F5A7F] hover:border-[#A8B5D0] transition-all duration-300 scroll-fade-in"
            style="background-color: rgba(11, 224, 187, 0.2);"
            @click="handleConsultation"
          >
            立即咨询&gt;
          </button>
        </div>
      </div>
    </div>
  </div>

</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount, watch, nextTick } from "vue";
import { useRoute, useRouter } from "vue-router";
import { productApi, serviceApi } from "@/api";
import { RequestError } from "@/utils/request";
import dxyyImg from "@/assets/img/dxyy.webp";
import d1Img from "@/assets/img/d1.webp";
import d2Img from "@/assets/img/d2.webp";
import d3Img from "@/assets/img/d3.webp";
import d4Img from "@/assets/img/d4.webp";
import d8Img from "@/assets/img/d8.webp";
import d6Img from "@/assets/img/d6.webp";
import d7Img from "@/assets/img/d7.webp";
import xr1Img from "@/assets/img/xr-1.webp";

const route = useRoute();
const router = useRouter();

// 产品详情数据
const productDetail = ref<any>(null);
const loading = ref(false);

// 从查询参数获取产品 id
const getProductId = (): string | null => {
  // 优先 query（兼容旧链接 product/detail?id=xxx）
  const qid = route.query.id as string | undefined;
  if (qid) return qid;

  // 新路径：/product/:id.html 或旧路径：/product/detail/:id
  const pid = route.params.id as string | undefined;
  return pid || null;
};

// 加载产品详情
const loadProductDetail = async () => {
  const productId = getProductId();
  if (!productId) {
    console.warn("未找到产品 ID");
    return;
  }

  loading.value = true;
  try {
    const response = await productApi.getProductDetail(productId);
    if (response.code === 200 && response.data) {
      productDetail.value = response.data;

      // SEO 信息已由路由守卫统一管理，不再在组件中设置
      // 路由守卫会从 API 获取 SEO 内容并更新页面标题和 meta 标签

      // 数据加载完成后，等待 DOM 更新后重新观察动画元素
      await nextTick();
      if (observer) {
        // 重新观察新添加的元素
        const elements = document.querySelectorAll(
          ".scroll-fade-in, .scroll-fade-in-left, .scroll-fade-in-right"
        );
        elements.forEach((element) => {
          if (observer && !animatedElements.has(element as HTMLElement)) {
            observer.observe(element);
          }
        });
      }
    } else {
      console.warn("产品详情响应格式异常:", response);
    }
  } catch (error) {
    console.error("加载产品详情失败:", error);
    if (error instanceof RequestError) {
      console.error("错误信息:", error.message);
    }
  } finally {
    loading.value = false;
  }
};

// 监听路由变化，重新加载数据
watch(
  () => [route.query.id, route.params.id],
  () => {
    loadProductDetail();
  },
  { immediate: false }
);

// 爱番番独立沟通链接（PC / 移动端）
const AFFIM_CHAT_URL_PC =
  "https://affim.baidu.com/unique_76738406/chat?siteId=22754352&userId=76738406&siteToken=0d1814da8c0c617ae6ea195eae32d27e";
const AFFIM_CHAT_URL_MOBILE =
  "https://affim.baidu.com/unique_76738406/mobile/chat?siteId=22754352&userId=76738406&siteToken=0d1814da8c0c617ae6ea195eae32d27e";

const handleConsultation = () => {
  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    ) || window.innerWidth < 768;
  const url = isMobile ? AFFIM_CHAT_URL_MOBILE : AFFIM_CHAT_URL_PC;
  window.open(url, "_blank", "noopener,noreferrer");
};

// 服务案例数据接口
interface ServiceCaseItem {
  image: string;
  title: string;
  description: string;
  link: string;
  id: string;
}

// 服务案例列表数据（接口获取，默认取前 4 个）
const serviceCaseList = ref<ServiceCaseItem[]>([]);

type CaseRaw = {
  id: string;
  title: string;
  image: string;
  content: string;
  address: string;
};

// 随机打乱数组并取前n个
const shuffleArray = <T>(array: T[]): T[] => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const a = shuffled[i];
    const b = shuffled[j];
    if (a !== undefined && b !== undefined) {
      shuffled[i] = b;
      shuffled[j] = a;
    }
  }
  return shuffled;
};

const loadServiceCaseList = async () => {
  try {
    const res = await serviceApi.getCaseList();
    const list = (res.data || []) as CaseRaw[];
    // 随机选择3个案例
    const shuffledList = shuffleArray(list);
    serviceCaseList.value = shuffledList.slice(0, 3).map((item) => ({
      id: item.id,
      title: item.title ?? "",
      description: item.content ?? "",
      image: item.image || xr1Img,
      link: "#",
    }));

    await nextTick();
    // 重新观察新加载的服务案例卡片（包含左右飞入动画）
    const caseElements = document.querySelectorAll(
      ".scroll-fade-in-left, .scroll-fade-in-right"
    );
    caseElements.forEach((el) => {
      const element = el as HTMLElement;
      if (!animatedElements.has(element)) {
        // 检查元素是否已经在视口中
        const rect = element.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight && rect.bottom > 0;

        if (isVisible) {
          // 如果元素已经在视口中，立即应用动画
          element.classList.add("fade-in-visible");
          animatedElements.add(element);
        } else if (observer) {
          // 否则开始观察
          observer.observe(element);
        }
      }
    });
  } catch (error) {
    console.error("加载服务案例失败:", error);
    if (error instanceof RequestError) {
      console.error("错误信息:", error.message);
    }
    serviceCaseList.value = [];
  }
};

// 跳转到案例详情页
const goToCaseDetail = (id: string) => {
  if (!id) return;
  router.push(`/service/case/${id}.html`);
};

// 跳转到服务页面
const goToServicePage = () => {
  router.push("/service");
};

// 场景数据数组（默认数据，如果接口返回数据则会被替换）
const scenes = ref([
  {
    title: "悬浮运输机",
    description:
      "冰冷的金属触感从脚底传来，头顶的全息投影骤然亮起。玩家正被束缚在一架悬浮运输机的舱内，磁暴手铐紧紧锁住手腕，泛着幽蓝的电流声。",
    image: d7Img,
  },
  {
    title: "模拟训练舱",
    description:
      "模拟训练舱内，训练者正被束缚在模拟舱内，磁暴手铐紧紧锁住手腕，泛着幽蓝的电流声。",
    image: d1Img,
  },
  {
    title: "虚拟治疗舱",
    description:
      "虚拟治疗舱内，治疗者正被束缚在治疗舱内，磁暴手铐紧紧锁住手腕，泛着幽蓝的电流声。",
    image: dxyyImg,
  },
  {
    title: "虚拟治疗舱",
    description:
      "虚拟治疗舱内，治疗者正被束缚在治疗舱内，磁暴手铐紧紧锁住手腕，泛着幽蓝的电流声。",
    image: d2Img,
  },
  {
    title: "虚拟治疗舱",
    description:
      "虚拟治疗舱内，治疗者正被束缚在治疗舱内，磁暴手铐紧紧锁住手腕，泛着幽蓝的电流声。",
    image: d3Img,
  },
  {
    title: "虚拟治疗舱",
    description:
      "虚拟治疗舱内，治疗者正被束缚在治疗舱内，磁暴手铐紧紧锁住手腕，泛着幽蓝的电流声。",
    image: d4Img,
  },
  {
    title: "虚拟治疗舱",
    description:
      "虚拟治疗舱内，治疗者正被束缚在治疗舱内，磁暴手铐紧紧锁住手腕，泛着幽蓝的电流声。",
    image: d8Img,
  },
  {
    title: "虚拟治疗舱",
    description:
      "虚拟治疗舱内，治疗者正被束缚在治疗舱内，磁暴手铐紧紧锁住手腕，泛着幽蓝的电流声。",
    image: d6Img,
  },
]);

// 存储已触发动画的元素
const animatedElements = new Set<HTMLElement>();

// Intersection Observer 配置
const observerOptions = {
  root: null,
  rootMargin: "0px",
  threshold: 0.1, // 当元素10%可见时触发
};

// 创建 Intersection Observer
let observer: IntersectionObserver | null = null;

// 观察动画元素的函数
const observeElements = () => {
  if (!observer) {
    // 创建 observer
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (
          entry.isIntersecting &&
          !animatedElements.has(entry.target as HTMLElement)
        ) {
          // 元素进入视口且未触发过动画
          const element = entry.target as HTMLElement;
          element.classList.add("fade-in-visible");
          animatedElements.add(element);
        }
      });
    }, observerOptions);
  }

  // 观察所有带有滚动动画类的元素（与 product/index.vue 保持一致）
  const elements = document.querySelectorAll(
    ".scroll-fade-in, .scroll-fade-in-left, .scroll-fade-in-right"
  );
  elements.forEach((element) => {
    if (observer && !animatedElements.has(element as HTMLElement)) {
      observer.observe(element);
    }
  });
};

onMounted(() => {
  // 加载产品详情
  loadProductDetail();

  // 加载服务案例（默认前 4 条）
  loadServiceCaseList();

  // 初始观察元素
  observeElements();
});

onBeforeUnmount(() => {
  if (observer) {
    observer.disconnect();
  }
});
</script>

<style scoped lang="scss">
.title-family-normal {
  font-family: "Noto Sans SC";
  font-weight: normal;
}

.title-family-12 {
  font-family: "Noto Sans SC";
  font-weight: normal;
}

// 滚动动画效果 - 小元素从底部飞入
.scroll-fade-in {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.scroll-fade-in.fade-in-visible {
  opacity: 1;
  transform: translateY(0);
}

// 滚动动画效果 - 从左边飞入
.scroll-fade-in-left {
  opacity: 0;
  transform: translateX(-50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.scroll-fade-in-left.fade-in-visible {
  opacity: 1;
  transform: translateX(0);
}

// 滚动动画效果 - 从右边飞入
.scroll-fade-in-right {
  opacity: 0;
  transform: translateX(50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.scroll-fade-in-right.fade-in-visible {
  opacity: 1;
  transform: translateX(0);
}

// 查看更多卡片样式
.more-case-card {
  background-color: rgba(11, 37, 91, 0.3);
}

.more-case-card:hover {
  background-color: rgba(11, 37, 91, 0.4);
}

// Hero Banner 响应式设计
@media (max-width: 1200px) {
  .hero-banner {
    min-height: 600px;
  }
}

@media (max-width: 768px) {
  .hero-banner {
    min-height: auto;
    padding: 2rem 0;

    > div > div {
      flex-direction: column;
      gap: 2rem;
    }
  }

  .product-intro {
    padding: 3rem 1rem;
  }

  .scene-effects {
    padding: 3rem 1rem;

    .grid {
      grid-template-columns: 1fr;
    }
  }
}
</style>
